import _str from "shared/util/_str";

export const FIELD_GENDER = "gender";
export const FIELD_ORIENTATION = "orientation";
export const MAX_TAGS = 5;
export const SELECT_TAGS_HEADER = _str(`Select up to ${MAX_TAGS}`);
export const UNDERLYING_HEADER = {
	[FIELD_ORIENTATION]: _str("I'm interested in"),
	[FIELD_GENDER]: _str("Include me in"),
};

export const FIELDS = [
	FIELD_GENDER,
	FIELD_ORIENTATION,
];

export const SUBFIELD = {
	nonbinary: "nonbinary",
	underlying: "underlying",
};

export const UNDERLYING_SUBHEADER = _str("Pick one");
export const UNDERLYING_DETAIL = _str("We know gender is not binary, and it doesn’t feel great to have to choose between these two options. We want you to feel like yourself here, so we’re working on changing this.");

export const AVAILABLE_UNDERLYING = {
	"orientation": [
		{
			"name": "Men",
			"id": "men",
			"sentence": "Men",
		},
		{
			"name": "Women",
			"id": "women",
			"sentence": "Women",
		},
		{
			"name": "Everyone",
			"id": "everyone",
			"sentence": "Everyone",
		},
	],
	"gender": [
		{
			"name": "Men",
			"id": "man",
			"sentence": "Searches for men",
		},
		{
			"name": "Women",
			"id": "woman",
			"sentence": "Searches for women",
		},
	],
};

export const AVAILABLE_TAGS = {
	"orientation": [
		{
			"id": "straight",
			"name": "Straight",
		},
		{
			"id": "gay",
			"name": "Gay",
		},
		{
			"id": "bisexual",
			"name": "Bisexual",
		},
		{
			"id": "lesbian",
			"name": "Lesbian",
		},
		{
			"id": "queer",
			"name": "Queer",
		},
		{
			"id": "pansexual",
			"name": "Pansexual",
		},
		{
			"id": "questioning",
			"name": "Questioning",
		},
		{
			"id": "heteroflexible",
			"name": "Heteroflexible",
		},
		{
			"id": "homoflexible",
			"name": "Homoflexible",
		},
		{
			"id": "asexual",
			"name": "Asexual",
		},
		{
			// id needs _ instead of -, which is in gentation.dict
			// since in pub api_helpers.prepare_api_key replaces - with _
			"id": "gray_asexual",
			"name": "Gray-asexual",
		},
		{
			"id": "demisexual",
			"name": "Demisexual",
		},
		{
			"id": "reciprosexual",
			"name": "Reciprosexual",
		},
		{
			"id": "akiosexual",
			"name": "Akiosexual",
		},
		{
			"id": "aceflux",
			"name": "Aceflux",
		},
		{
			"id": "grayromantic",
			"name": "Grayromantic",
		},
		{
			"id": "demiromantic",
			"name": "Demiromantic",
		},
		{
			"id": "recipromantic",
			"name": "Recipromantic",
		},
		{
			"id": "akioromantic",
			"name": "Akioromantic",
		},
		{
			"id": "aroflux",
			"name": "Aroflux",
		},
	],

	"gender": [
		{
			"name": "Woman",
			"id": "woman",
			"name_plural": "Women",
		},
		{
			"name": "Man",
			"id": "man",
			"name_plural": "Men",
		},
		{
			"name": "Agender",
			"id": "agender",
			"name_plural": "Agenders",
		},
		{
			"name": "Androgynous",
			"id": "androgynous",
			"name_plural": "Androgynes",
		},
		{
			"name": "Bigender",
			"id": "bigender",
			"name_plural": "Bigenders",
		},
		{
			"name": "Cis Man",
			"id": "cis_man",
			"name_plural": "Cis Men",
		},
		{
			"name": "Cis Woman",
			"id": "cis_woman",
			"name_plural": "Cis Women",
		},
		{
			"name": "Genderfluid",
			"id": "genderfluid",
			"name_plural": "Genderfluids",
		},
		{
			"name": "Genderqueer",
			"id": "genderqueer",
			"name_plural": "Genderqueers",
		},
		{
			"name": "Gender Nonconforming",
			"id": "gender_nonconforming",
			"name_plural": "Genders Nonconforming",
		},
		{
			"name": "Hijra",
			"id": "hijra",
			"name_plural": "Hijras",
		},
		{
			"name": "Intersex",
			"id": "intersex",
			"name_plural": "Intersexes",
		},
		{
			"name": "Non-binary",
			"id": "non_binary",
			"name_plural": "Non-binaries",
		},
		{
			"name": "Other",
			"id": "other",
			"name_plural": "Others",
		},
		{
			"name": "Pangender",
			"id": "pangender",
			"name_plural": "Pangenders",
		},
		{
			"name": "Transfeminine",
			"id": "transfeminine",
			"name_plural": "Transfeminines",
		},
		{
			"name": "Transgender",
			"id": "transgender",
			"name_plural": "Transgender",
		},
		{
			"name": "Transmasculine",
			"id": "transmasculine",
			"name_plural": "Transmasculines",
		},
		{
			"name": "Transsexual",
			"id": "transsexual",
			"name_plural": "Transsexuals",
		},
		{
			"name": "Trans Man",
			"id": "trans_man",
			"name_plural": "Trans Men",
		},
		{
			"name": "Trans Woman",
			"id": "trans_woman",
			"name_plural": "Trans Women",
		},
		{
			"name": "Two Spirit",
			"id": "two_spirit",
			"name_plural": "Two Spirits",
		},
	],
};



// WEBPACK FOOTER //
// ./src/apps/nonbinary/util/constants.js